import { Effect, Context, Layer } from 'effect';
export class TokenError {
    source;
    _tag = 'TokenError';
    constructor(source) {
        this.source = source;
    }
}
export class TokenProviderService extends Context.Tag('@fixtuur/backpack/TokenProviderService')() {
}
export const getToken = () => Effect.fail(new TokenError('Not Yet Implemented'));
export const TokenProviderServiceLive = Layer.sync(TokenProviderService, () => ({
    getToken,
}));
